import type {HelpFile} from '../../types/help'
import {ConditionsEditorTestIds} from '../../../testids/ConditionsEditorTestIds'

export const conditionsEditorHelp: HelpFile = {
    docPage: '/docs/governance/certification-policies',
    texts: {
        [ConditionsEditorTestIds.btnAddCondition]:
            'Add a field / operator / value row. Each field + operator pair can be used once.',
        [ConditionsEditorTestIds.conditionsEmptyInfo]: null,
        [ConditionsEditorTestIds.conditionsEmptyHint]: null,
    },
}
